import React, { useEffect, useRef, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRoomContext } from '../../../../RoomContext';
import { FormattedMessage, useIntl } from 'react-intl';
import * as toolareaActions from '../../../../store/actions/toolareaActions';
import '../styles.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { makePermissionSelector } from '../../../../store/selectors';
import { permissions } from '../../../../permissions';
import DotSpinLoader from '../../../Loader/dotSpinLoader';
import './styles.css';
import CloseBtn from '../../closeBtn';
import GradientButton from '../../../customMui/newButton/newButton';
import axios from 'axios';
import { getPollingData } from '../../../../libs/apis/pollingApi';
import { store } from '../../../../store/store';

const styles = () =>
	({
		root :
		{
			display       : 'flex',
			flexDirection : 'column',
			padding       : '0.5rem 0'
		},
		flexInline :
		{
			display : 'inline-flex',
			flex    : 'none'
		},
		list :
			{
				listStyleType   : 'none',
				// boxShadow       : '0 2px 5px 2px rgba(0, 0, 0, 0.2)',
				backgroundColor : 'rgba(255, 255, 255, 1)'
			},
		listheader :
			{
				fontWeight : 'bolder'
			},
		pdngHSM :
		{
			padding : '0 0.75rem'
		},
		flexRow :
		{
			display : 'flex',
			flex    : 'none'
		},
		justifyBtwn :
		{
			justifyContent : 'space-between'
		},
		pdngSM :
		{
			padding : '0.75rem'
		},
		alignCntr :
		{
			alignItems : 'center'
		},
		brdrBSM :
		{
			borderBottom : '1px solid lightgrey'
		},
		pdngXSM :
		{
			padding : '0.5rem'
		}

	});

const PollingQuestionList = (props) =>
{
	const intl = useIntl();
	const {
		// classes,
		setToolTab,
		roomClient,
		handleResultPollObj,
		isModerator,
		handlePeerOpenPoll,
		currentModifyingPollObj,
		handlePollingDialogue,
		toggleToolArea,
		myId,
		modifyingPoll,
		setPollingTabs,
		setPollingActive,
		webinarData,
		webinarUser,
		setSideComp,
		handleClose,
		pollingsList
	} = props;

	const [ pollingList, setPollingList ] = useState([]);
	const [ peerPolls, setPeerPolls ] = useState([]);
	const [ isLoading, setIsLoading ] = useState(true);
	const [ more, setMore ] = useState(false);
	const [ moreI, setMoreI ] = useState(null);
	const componentRef = useRef(null);

	const handleClick = (index) =>
	{
		setMoreI(index);
		setMore(!more);
	};

	// const handleClose = () =>
	// {
	// 	setMore(null);
	// };

	const getallpollings = async () =>
	{
		setIsLoading(true);
		try
		{
			const meetingDetailsData = await roomClient.getMeetingInfo();
			// eslint-disable-next-line max-len
			const res = await getPollingData(webinarData?._id ? webinarData?._id : meetingDetailsData?.meetingDetails?.meetingId, webinarData?.sessionId ? webinarData?.sessionId : store.getState().room?.name);

			if (res.status)
			{
				setPollingList(res.data);
				const poolData=res.data.filter((pool) => (pool.isActive || pool.isPublishResult));

				setPeerPolls(poolData);
				setIsLoading(false);
			}
		}
		catch (error)
		{
			toast.error(error?.message);
			setIsLoading(false);
		}
	};

	useEffect(() =>
	{
		getallpollings();
		setPollingTabs('single choice');
	}, [ pollingsList ]);

	const handlePublish = (poll) =>
	{
		if (poll.isActive === false)
		{
			setPollingActive(true);
			setIsLoading(true);
			axios.put(`${import.meta.env.VITE_USERS}/publishpolling/${poll?.meetingId}/${poll?.sessionId}/${poll?._id}`)
				.then((response) =>
				{

					if (response.data.status)
					{
						toast.success(intl.formatMessage({ id: 'pollStartSuccess', defaultMessage: 'You’ve successfully started the poll!' }));
						roomClient.sendPolling(response.data.data);
						getallpollings();
					}
					setIsLoading(false);
				})
				.catch((error) =>
				{

					toast.error(error?.message);
					setIsLoading(false);
				});
		}
	};

	const handleModify = (poll) =>
	{
		modifyingPoll(poll);
		setToolTab('addPolls');
	};

	const handleStop = (poll) =>
	{
		if (poll.isStop === undefined || poll.isStop === false)
		{
			setPollingActive(false);
			setIsLoading(true);
			axios.put(`${import.meta.env.VITE_USERS}/stopPolling/${poll?.meetingId}/${poll?.sessionId}/${poll?._id}`)
				.then((response) =>
				{

					if (response.data.status)
					{
						toast.success(intl.formatMessage({ id: 'pollStopSuccess', defaultMessage: 'You’ve successfully stopped the poll!' }));
						getallpollings();
						roomClient.sendPolling({});
					}
					setIsLoading(false);
				})
				.catch((error) =>
				{

					toast.error(error?.message);
					setIsLoading(false);
				});
		}
	};

	const handleResult = (poll) =>
	{

		// if (poll?.isStop)
		// {

		handleResultPollObj(poll);
		setToolTab('pollResult');
		// }
		// else
		// {
		// 	toast.error('You need to stop polling to get results');
		// }
	};

	const handlePeerResult = (poll) =>
	{

		if (webinarUser)
		{

			handleResultPollObj(poll);
			setSideComp('pollResult');
		}
		else
		{
			handleResultPollObj(poll);
			setToolTab('pollResult');
		}
	};

	const handlePeerStart = (poll) =>
	{
		handlePeerOpenPoll(poll);
		handlePollingDialogue(true);
		toggleToolArea();
		setToolTab('');
	};

	const handleDeletepoll = (poll) =>
	{
		setIsLoading(true);
		axios.delete(`${import.meta.env.VITE_USERS}/deletepoll/${poll?._id}`)
			.then((response) =>
			{

				if (response.data.status)
				{
					toast.success(intl.formatMessage({ id: 'pollDeleteSuccess', defaultMessage: 'You’ve successfully deleted the poll!' }));
					getallpollings();
				}
				setIsLoading(false);
			})
			.catch((error) =>
			{

				toast.error(error?.message);
				setIsLoading(false);
			});
	};

	const addNewPool = () =>
	{
		setToolTab('addPolls');
		currentModifyingPollObj.questionType ='single';
	};

	// const closeDrawer = () =>
	// {
	// 	toggleToolArea();
	// };

	const handleClickOutside = (event) =>
	{
		if (componentRef.current && !componentRef.current.contains(event.target))
		{
			setMore(null);
			setMoreI(null);
		}
	};

	useEffect(() =>
	{
		document.addEventListener('mousedown', handleClickOutside);

		return () =>
		{
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	return (
		<div className='flexMinWidthCol fullHeight'>
			{/* {isLoading ? <DotSpinLoader/> : */}
			{pollingList.length === 0 ?
				<div className='flexCol fullH'>
					<div className='flexRow  pdngSM'>
						<div className='flexAutoRow'>
							{webinarUser ? <img src='icons/close.svg' alt='back' className='pointer' onClick={handleClose}/> : <CloseBtn/>}
						</div>
						<div className='flexMinWidthRow jCntr'>
							<span className='mHdng'>{intl.formatMessage({ id: 'label.polls', defaultMessage: 'Polls' })}</span>

						</div>
					</div>
					<div className='flexCol justifyCntr alignCntr poliListCntnr'>
						<div className='flexRow jCntr aCntr pdngVMD'>
							<img src='/images/noPolls.svg' alt='noPolls' />
						</div>
						<span className='pollsTxt pdngVSM'>{intl.formatMessage({ id: 'label.noPolls', defaultMessage: 'No polls added yet' })}</span>
						{isModerator &&
							<div className='flexInline pdngVSM'>
								<GradientButton
									color='primary'
									variant='contained'
									disableElevation
									onClick={addNewPool}
								>
									<FormattedMessage
										id='label.addPoll'
										defaultMessage='Add Poll'
									/>
								</GradientButton>
							</div>}
					</div>
				</div>
				:
				isModerator ?
					<div className='flexCol fullHeight'>
						<div className='flexRow aCntr pdngSM'>
							{/* <img src='icons/close.svg' alt='close' className='pointer' onClick={closeDrawer} /> */}
							{webinarUser ? <img src='icons/close.svg' alt='back' className='pointer' onClick={handleClose}/> : <CloseBtn/>}
							<div className='flexMinWidthCol aCntr'>
								<span className='mHdng'>
									<b>
										{intl.formatMessage({ id: 'label.polls', defaultMessage: 'Polls' })}
									</b>
								</span>
							</div>
						</div>
						<div className='flexRow aCntr jBtwn pdngSM'>
							<span>{intl.formatMessage({ id: 'label.polls', defaultMessage: 'Polls' })}</span>
							<div className='flexAutoRow pointer' onClick={addNewPool}>
								<span>{intl.formatMessage({ id: 'label.add', defaultMessage: 'Add' })}</span>
								<img src='/icons/plus.svg' alt='add' />
							</div>
						</div>
						<div className='flexCol  gap16 poliListCntnr'>
							{pollingList.map((each, index) => (
								<div key={each._id} className='flexCol brdrBSM pdngBSM'>
									<div className='flexCol pdngSM newPollTab aEnd'>
										<div className='flexRow aCntr pdngSM'>
											<div className='flexMinWidthCol'>
												<span className='ellipse'>{each.question}</span>
											</div>
											{!each.isActive &&
												<div className='flexInlineCol moreCntnr'>
													<img className='pointer' src='/icons/dots.svg' alt='more' onClick={() => handleClick(index)}/>
													{ more && index === moreI &&
													<div className='flexAutoCol moreTab' ref={componentRef}>
														<span className='pdngSM pointer' onClick={(e) => { e.stopPropagation(); handleModify(each); setMore(false); }}>{intl.formatMessage({ id: 'room.edit', defaultMessage: 'Edit' })}</span>
														<span className='pdngSM pointer' onClick={(e) => { e.stopPropagation(); handleDeletepoll(each); setMore(false); }}>{intl.formatMessage({ id: 'label.delete', defaultMessage: 'Delete' })}</span>
													</div>
													}
												</div>
											}
										</div>
										{each.isActive ?
											<div className='flexRow gap16 jEnd'>
												{(each.isStop === undefined || each.isStop === false) &&
													<GradientButton color='primary' variant='contained' size='small' disableElevation onClick={() => handleStop(each)} >{intl.formatMessage({ id: 'label.stop', defaultMessage: 'Stop' })}</GradientButton>
												}
												<GradientButton color='primary' variant='contained' size='small' disableElevation onClick={() => handleResult(each)} >{intl.formatMessage({ id: 'label.result', defaultMessage: 'Result' })}</GradientButton>
											</div>
											:
											<GradientButton color='primary' variant='contained' size='small' disableElevation onClick={() => handlePublish(each)} >{intl.formatMessage({ id: 'label.start', defaultMessage: 'Start' })}</GradientButton>
										}
									</div>
								</div>

							))}
						</div>
					</div>
					:
					(peerPolls && peerPolls.length>0) ?
						<div className='flexCol fullH'>
							<div className='flexRow aCntr pdngSM'>
								{/* <img src='icons/close.svg' alt='close' className='pointer' onClick={closeDrawer} /> */}
								{webinarUser ? <img src='icons/close.svg' alt='back' className='pointer' onClick={handleClose}/> : <CloseBtn/>}
								<div className='flexMinWidthCol aCntr'>
									<span className='mHdng'>
										{intl.formatMessage({ id: 'label.polls', defaultMessage: 'Polls' })}
									</span>
								</div>
							</div>
							<div className='flexCol pdngSM gap16 poliListCntnr1'>
								{peerPolls.map((each) => (
									<div key={each._id} className='flexCol pdngSM newPollTab aEnd'>
										<div className='flexRow aCntr mrgnBSM '>
											<div className='flexMinWidthCol'>
												<span className='ellipse'>{each.question}</span>
											</div>
										</div>
										{each.isPublishResult ?
											<div className='flexRow gap16 jEnd'>
												<GradientButton color='primary' variant='contained' size='small' disableElevation onClick={() => handlePeerResult(each)} >
													<FormattedMessage
														id='start'
														defaultMessage={'Result'}
													/>
												</GradientButton>
											</div>
											:
											(!each.isStop && <div className='flexRow gap16 jEnd'>
												<GradientButton color='primary' variant='contained' size='small' disableElevation onClick={() => handlePeerStart(each)} >
													<FormattedMessage
														id='start'
														defaultMessage={each.submittedUsers?.includes(myId) ? 'Modify' : 'Start'}
													/>
												</GradientButton>
											</div>)
										}
									</div>
								))}
							</div>
						</div>
						:
						<div className='flexCol justifyCntr alignCntr fullHeight'>
							<div className='flexRow aCntr pdngSM'>
								{webinarUser ? <img src='icons/close.svg' alt='back' className='pointer' onClick={handleClose}/> : <CloseBtn/>}
								<div className='flexMinWidthCol aCntr'>
									<span className='mHdng'>
										{intl.formatMessage({ id: 'label.polls', defaultMessage: 'Polls' })}
									</span>
								</div>
							</div>
							<div className='flexMinWidthCol justifyCntr alignCntr'>
								<img src='/images/noPolls.svg' alt='noPolls' />
								<span className='pollsTxt'>
									<FormattedMessage
										id='label.noPolls'
										defaultMessage='No polls added yet'
									/>
								</span>
							</div>

						</div>
			}
			<ToastContainer
				position='top-right'
				autoClose={3000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnVisibilityChange
				draggable
				pauseOnHover
			/>
			{isLoading && <DotSpinLoader/>}
		</div>
	);
};

PollingQuestionList.propTypes =
{
	roomClient              : PropTypes.object.isRequired,
	// classes                 : PropTypes.object.isRequired,
	setToolTab              : PropTypes.func,
	handleResultPollObj     : PropTypes.func,
	currentModifyingPollObj : PropTypes.any,
	isModerator             : PropTypes.bool.isRequired,
	handlePeerOpenPoll      : PropTypes.func,
	handlePollingDialogue   : PropTypes.func,
	toggleToolArea          : PropTypes.func,
	myId                    : PropTypes.string,
	modifyingPoll           : PropTypes.func,
	setPollingTabs          : PropTypes.func,
	setPollingActive        : PropTypes.any,
	webinarData             : PropTypes.any,
	webinarUser             : PropTypes.any,
	setSideComp             : PropTypes.any,
	handleClose             : PropTypes.any,
	pollingsList            : PropTypes.any
};
const makeMapStateToProps = () =>
{
	const hasPermission = makePermissionSelector(permissions.MODERATE_ROOM);
	const mapStateToProps = (state) => ({
		myId                    : state.me.id,
		settings                : state.settings,
		pollingTab              : state.toolarea,
		handleResultPollObj     : state.toolarea,
		isModerator             : hasPermission(state),
		handlePeerOpenPoll      : state.toolarea,
		modifyingPoll           : state.toolarea,
		currentModifyingPollObj : state.toolarea.currentModifyingPollObj,
		webinarData             : state.webinar.webinarData,
		pollingsList            : state.toolarea

	});

	return mapStateToProps;

};

const mapDispatchToProps = (dispatch) => ({
	setToolTab : (tab) =>
		dispatch(toolareaActions.setToolTab(tab)),
	// eslint-disable-next-line max-len
	handleResultPollObj   : (pollId) => dispatch(toolareaActions.handleResultPollObj(pollId)),
	handlePeerOpenPoll    : (poll) => dispatch(toolareaActions.handlePeerOpenPoll(poll)),
	// eslint-disable-next-line max-len
	handlePollingDialogue : (isPollOpen) => dispatch(toolareaActions.handlePollingDialogue(isPollOpen)),
	modifyingPoll         : (add) => dispatch(toolareaActions.modifyingPoll(add)),
	// eslint-disable-next-line max-len
	setPollingTabs        : (selectedTab) => dispatch(toolareaActions.setPollingTabs(selectedTab)),
	// toggleToolArea        : () =>
	// {
	// 	dispatch(toolareaActions.toggleToolArea());
	// },

	setPollingActive : (pollingActive) =>
	{
		dispatch(toolareaActions.setPollingActive(pollingActive));
	}
});

export default withRoomContext(connect(
	makeMapStateToProps,
	// mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.myId === next.myId &&
				prev.settings === next.settings &&
				prev.toolarea.pollingTab === next.toolarea.pollingTab &&
				prev.toolarea.handleResultPollObj === next.toolarea.handleResultPollObj &&
				prev.toolarea.handlePollingAdd === next.toolarea.handlePollingAdd &&
				prev.toolarea.currentModifyingPollObj === next.toolarea.currentModifyingPollObj &&
				prev.webinar.webinarData === next.webinar.webinarData &&
				prev.toolarea.pollingsList === next.toolarea.pollingsList
			);
		}
	}
)(withStyles(styles)(PollingQuestionList)));